/* ============================================================
   YOONSEUL · Motor de movimiento de las secciones ys-clean-*
   Idempotente: se puede volver a lanzar sin duplicar listeners.
   Respeta prefers-reduced-motion. Sin JS, todo queda visible.

   CORRECCIÓN 19-09-2026 · contadores atascados en 1
   El marcador de «ya inicializado» se guardaba con el nombre de la
   propia clave de datos (el.dataset.yscCount = '1'), así que pisaba
   data-ysc-count, data-ysc-bar, data-ysc-zoom y data-ysc-sticky con
   el valor 1 ANTES de leerlos. Ahora el marcador vive en un registro
   aparte (WeakSet) y no toca ningún atributo del HTML.
   ============================================================ */
(function () {
  'use strict';
  if (window.YSClean) { window.YSClean.init(); return; }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observers = [];

  /* Registro de elementos ya inicializados, por tipo de componente.
     No escribe nada en el DOM, así que no puede sobrescribir un dato. */
  var registros = Object.create(null);
  function marcado(el, llave) {
    var reg = registros[llave];
    if (reg === undefined) {
      reg = registros[llave] = (typeof WeakSet === 'function') ? new WeakSet() : null;
    }
    if (reg) {
      if (reg.has(el)) return true;
      reg.add(el);
      return false;
    }
    var prop = '__ysc_' + llave;
    if (el[prop]) return true;
    el[prop] = true;
    return false;
  }

  /* Formato español con los decimales que pida cada cifra. */
  var formateadores = {};
  function formateador(dec) {
    if (!formateadores[dec]) {
      formateadores[dec] = new Intl.NumberFormat('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    }
    return formateadores[dec];
  }

  /* Acepta 28.54 y 28,54. Devuelve NaN si no hay número. */
  function aNumero(txt) {
    if (txt === null || txt === undefined) return NaN;
    return parseFloat(String(txt).trim().replace(/\s/g, '').replace(',', '.'));
  }

  /* ---------- Entradas suaves ---------- */
  function reveals(raiz) {
    var items = raiz.querySelectorAll('.ysc-reveal');
    if (!items.length) return;
    if (reduce.matches) { items.forEach(function (n) { n.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px' });
    items.forEach(function (n) { if (!marcado(n, 'reveal')) io.observe(n); });
    observers.push(io);
  }

  /* ---------- Contadores ---------- */
  function pintar(el, valor, dec, pre, suf) {
    el.textContent = (pre || '') + formateador(dec).format(valor) + (suf || '');
  }

  function contadores(raiz) {
    var items = raiz.querySelectorAll('[data-ysc-count]');
    if (!items.length) return;
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var destino = aNumero(el.getAttribute('data-ysc-count'));
        var dec = parseInt(el.getAttribute('data-ysc-dec'), 10);
        if (!(dec >= 0 && dec <= 3)) dec = 2;
        var pre = el.getAttribute('data-ysc-pre') || '';
        var suf = el.getAttribute('data-ysc-suf') || '';
        var dur = parseInt(el.getAttribute('data-ysc-dur'), 10);
        if (!(dur > 0)) dur = 1600;
        /* Sin número utilizable se respeta el HTML de partida, que ya trae la cifra final. */
        if (!isFinite(destino)) return;
        if (reduce.matches) { pintar(el, destino, dec, pre, suf); return; }
        var t0 = null;
        function paso(t) {
          if (t0 === null) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var e2 = 1 - Math.pow(1 - p, 3);
          pintar(el, destino * e2, dec, pre, suf);
          if (p < 1) requestAnimationFrame(paso);
          else pintar(el, destino, dec, pre, suf);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -40px' });
    items.forEach(function (n) { if (!marcado(n, 'count')) io.observe(n); });
    observers.push(io);
  }

  /* ---------- Barras comparativas ---------- */
  function barras(raiz) {
    var items = raiz.querySelectorAll('[data-ysc-bar]');
    if (!items.length) return;
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var pct = aNumero(e.target.getAttribute('data-ysc-bar'));
        if (!isFinite(pct)) return;
        e.target.style.width = Math.max(0, Math.min(100, pct)) + '%';
      });
    }, { threshold: 0.35 });
    items.forEach(function (n) { if (!marcado(n, 'bar')) io.observe(n); });
    observers.push(io);
  }

  /* ---------- Marquee ---------- */
  function marquees(raiz) {
    raiz.querySelectorAll('.ysc-marquee').forEach(function (m) {
      if (marcado(m, 'marquee')) return;
      var btn = m.querySelector('.ysc-marquee__pause');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var pausado = m.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', pausado ? 'true' : 'false');
        btn.textContent = pausado ? '▶' : '‖';
      });
    });
  }

  /* ---------- Carrusel de destacados ---------- */
  function carruseles(raiz) {
    raiz.querySelectorAll('[data-ysc-carousel]').forEach(function (c) {
      if (marcado(c, 'carousel')) return;
      var pista = c.querySelector('.ysc-fav__track');
      var prev = c.querySelector('[data-ysc-prev]');
      var next = c.querySelector('[data-ysc-next]');
      if (!pista) return;
      function paso() {
        var card = pista.querySelector('.ysc-fav__card');
        return card ? card.getBoundingClientRect().width + 20 : pista.clientWidth * 0.8;
      }
      function estado() {
        if (prev) prev.disabled = pista.scrollLeft <= 4;
        if (next) next.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
      pista.addEventListener('scroll', estado, { passive: true });
      estado();
    });
  }

  /* ---------- Ampliación de fotos (un único diálogo) ---------- */
  var dlg = null;
  function dialogo() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'ysc-zoom ysc';
    dlg.innerHTML = '<button type="button" class="ysc-zoom__close" aria-label="Cerrar">×</button><img alt="">';
    document.body.appendChild(dlg);
    var ultimo = null;
    dlg.querySelector('.ysc-zoom__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (ultimo && document.contains(ultimo)) ultimo.focus();
    });
    dlg.abrirCon = function (src, alt, origen) {
      ultimo = origen || null;
      var img = dlg.querySelector('img');
      img.src = src; img.alt = alt || '';
      document.documentElement.style.overflow = 'hidden';
      dlg.showModal();
    };
    return dlg;
  }

  function zooms(raiz) {
    raiz.querySelectorAll('[data-ysc-zoom]').forEach(function (b) {
      if (marcado(b, 'zoom')) return;
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-ysc-zoom');
        var img = b.querySelector('img');
        if (src) dialogo().abrirCon(src, img ? img.alt : '', b);
      });
    });
  }

  /* ---------- Galería de la ficha ---------- */
  function galerias(raiz) {
    raiz.querySelectorAll('[data-ysc-gallery]').forEach(function (g) {
      if (marcado(g, 'gallery')) return;
      var principal = g.querySelector('[data-ysc-gallery-main]');
      if (!principal) return;
      g.querySelectorAll('.ysc-pdp__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          g.querySelectorAll('.ysc-pdp__thumb').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true');
          principal.src = t.getAttribute('data-ysc-full') || t.querySelector('img').src;
          principal.alt = t.getAttribute('data-ysc-alt') || '';
        });
      });
    });
  }

  /* ---------- FAQ: una abierta cada vez ---------- */
  function faqs(raiz) {
    raiz.querySelectorAll('[data-ysc-faq-solo]').forEach(function (lista) {
      if (marcado(lista, 'faq')) return;
      lista.addEventListener('toggle', function (e) {
        var d = e.target;
        if (d.tagName !== 'DETAILS' || !d.open) return;
        lista.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      }, true);
    });
  }

  /* ---------- Barra móvil de compra ---------- */
  function sticky(raiz) {
    raiz.querySelectorAll('[data-ysc-sticky]').forEach(function (barra) {
      if (marcado(barra, 'sticky')) return;
      var sel = barra.getAttribute('data-ysc-sticky');
      if (!sel) return;
      var ancla = null;
      try { ancla = document.querySelector(sel); } catch (err) { return; }
      if (!ancla) return;
      var io = new IntersectionObserver(function (e) {
        barra.classList.toggle('is-on', !e[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(ancla);
      observers.push(io);
    });
  }

  function init(raiz) {
    var r = raiz || document;
    document.documentElement.classList.add('ysc-motion-on');
    reveals(r); contadores(r); barras(r); marquees(r);
    carruseles(r); zooms(r); galerias(r); faqs(r); sticky(r);
  }

  window.YSClean = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* El editor recarga secciones sueltas: se reinicializa solo esa rama. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Antes, al descargar una sección se desconectaban TODOS los observadores
     y el resto de la página se quedaba sin animación tras cualquier recarga
     en el editor. Los observadores de la sección retirada se quedan sin
     elementos y el navegador los descarta solo. */
})();
